import { useKeycloak } from "@react-keycloak/web";
import axios, { AxiosInstance } from "axios";
import { useEffect, useState } from "react";

/**
 * Creates a prefconfigured axios wrapper that also talks with
 * the keycloak instance.
 */
export const useAxios = () => {
  const { keycloak, initialized } = useKeycloak();
  const [axiosInstance, setAxiosInstance] = useState({});
  const baseURL = process.env.REACT_APP_PROMODX_SERVICE_URL;

  useEffect(() => {
    if (keycloak) {
      const instance = axios.create({
        baseURL,
        headers: {
          Authorization: initialized ? `Bearer ${keycloak.token}` : undefined,
          "Content-Type": "application/json;charset=UTF-8",
        },
      });

      setAxiosInstance({ instance });
    }
    return () => {
      setAxiosInstance({});
    };
  }, [baseURL, initialized, keycloak]);

  return (axiosInstance as any).instance as AxiosInstance;
};
